import { computed, toValue } from 'vue'
import { useI18n } from 'vue-i18n'

const months = [
  { cs: 'ledna', en: 'January' },
  { cs: 'února', en: 'February' },
  { cs: 'března', en: 'March' },
  { cs: 'dubna', en: 'April' },
  { cs: 'května', en: 'May' },
  { cs: 'června', en: 'June' },
  { cs: 'července', en: 'July' },
  { cs: 'srpna', en: 'August' },
  { cs: 'září', en: 'September' },
  { cs: 'října', en: 'October' },
  { cs: 'listopadu', en: 'November' },
  { cs: 'prosince', en: 'December' },
]

interface UseFormattedDateOptions {
  shortFormat?: boolean
}

export const useFormattedDate = (
  startDateInput: any,
  endDateInput?: any,
  options: UseFormattedDateOptions = {},
) => {
  const { locale } = useI18n()

  return computed(() => {
    const startDate = toValue(startDateInput)
    const endDate = toValue(endDateInput)
    if (!startDate) return ''

    const startDateData = new Date(startDate)
    const endDateData = new Date(endDate)

    if (isNaN(startDateData.getTime())) return ''

    const isEn = locale.value === 'en'
    const dot = isEn ? '' : '.'

    const startDateDay = startDateData.getDate()
    const startDateMonth =
      months[startDateData.getMonth()]?.[locale.value as 'cs' | 'en']
    const startDateYear = startDateData.getFullYear()
    const startDateHours = String(startDateData.getHours()).padStart(2, '0')
    const startDateMinutes = String(startDateData.getMinutes()).padStart(2, '0')

    // Short format: "day month year"
    if (options.shortFormat) {
      return `${startDateDay}${dot} ${startDateMonth} ${startDateYear}`
    }

    const endDateDay = endDateData.getDate()
    const endDateMonth =
      months[endDateData.getMonth()]?.[locale.value as 'cs' | 'en']
    const endDateYear = endDateData.getFullYear()
    const endDateHours = String(endDateData.getHours()).padStart(2, '0')
    const endDateMinutes = String(endDateData.getMinutes()).padStart(2, '0')

    const isSameDay =
      startDate &&
      endDate &&
      startDateDay === endDateDay &&
      startDateMonth === endDateMonth &&
      startDateYear === endDateYear

    const isSameYear = startDateYear === endDateYear

    if (startDate && endDate && !isSameDay) {
      if (isEn && isSameYear) {
        return `${startDateDay} ${startDateMonth} – ${endDateDay} ${endDateMonth} ${endDateYear}`
      }
      return `${startDateDay}${dot} ${startDateMonth} ${startDateYear} – ${endDateDay}${dot} ${endDateMonth} ${endDateYear}`
    } else if (isSameDay) {
      return `${startDateDay}${dot} ${startDateMonth} ${startDateYear}`
    } else if (startDate) {
      return `${startDateDay}${dot} ${startDateMonth} ${startDateYear}, ${isEn ? 'from' : 'od'} ${startDateHours}:${startDateMinutes}`
    }
  })
}
